import axios from "../../config/axiosConfig";
import { GET_REPORT_MASTER, REPORT_MASTER_REQUEST, REPORT_MASTER_REQUEST_SUCCESS, REPORT_MASTER_REQUEST_FAILURE, CREATE_REPORT_MASTER, UPDATE_REPORT_MASTER, DELETE_REPORT_MASTER } from "../types";

export const getReportMaster = (params) => {
    return async(dispatch, getState) => {
        try{
            dispatch({type: REPORT_MASTER_REQUEST})
            const { auth } = getState();
            const defaultParams = {
                // userId: auth.user?.id,
                // finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/report-master/getAll?${queryString}`;
            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                    dispatch({ type: GET_REPORT_MASTER, payload: response.data });
                    dispatch({ type: REPORT_MASTER_REQUEST_SUCCESS });
                }
            }).catch((error) => {
                console.error("Error fetching Report Master:", error);
                dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
            });
        }
        catch(error){
            console.error("Error fetching Report Master:", error);
            dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
        }
    }
};

export const createReportMaster = (reportMaster) => {
    return async(dispatch, getState) => {
        try{
            const { auth } = getState();
            dispatch({ type: REPORT_MASTER_REQUEST });
            return axios.post("/report-master/add", reportMaster,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_REPORT_MASTER, payload: response.data });
                    dispatch({ type: REPORT_MASTER_REQUEST_SUCCESS });
                } else {
                    dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: "Report Master create failed." });
                }
            }).catch((error) => {
                console.error("Error creating Report Master:", error);
                dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error("Error creating Report Master:", error);
            dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    }
};

export const updateReportMaster = (data) => {
    return async(dispatch, getState) => {
        try{
            dispatch({ type: REPORT_MASTER_REQUEST });
            const { auth } = getState();

            const userId = auth.user?.id;

            // Log cURL equivalent
            const curlCommand = `curl -X PUT "report-master/update?userId=${userId}" \
            -H "Content-Type: application/json" \
            -d '${JSON.stringify({ data })}'`;

            console.log('CurlCommand>>>', curlCommand);

            return axios.put("/report-master/update", { data },
                { params: { userId: auth.user?.id, customerId: auth.user?.Customer_Id, companyId: auth.company?.id } }
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_REPORT_MASTER, payload: { data: response.data } });
                    dispatch({ type: REPORT_MASTER_REQUEST_SUCCESS });
                } else {
                    dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: "Report Master update failed." });
                }
            }).catch((error) => {
                console.error("Error updating Report Master:", error);
                dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error("Error updating Report Master:", error);
            dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    }
};

export const deleteReportMaster = (id) => {
    return async(dispatch) => {
        try{
            dispatch({ type: REPORT_MASTER_REQUEST });
            return axios.delete(`/report-master/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_REPORT_MASTER, payload: id });
                    dispatch({ type: REPORT_MASTER_REQUEST_SUCCESS });
                } else{
                    dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: "Report Master delete failed." });
                }
            }).catch((error) => {
                console.error("Error deleting Report Master:", error);
                dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        }
        catch(error){
            console.error("Error deleting Report Master:", error);
            dispatch({ type: REPORT_MASTER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    }
};
